import { ref } from 'vue';

interface ImageLoaderOptions {
    pattern: string;
    name: string;
}

const images = import.meta.glob('../../assets/img/**/*.*', { eager: true });

export const useImagesLoader = () => {
    const imageSrc = ref<string | undefined>();

    const loadImage = (iconName: string): string | undefined => {
        const extensions = ['png', 'jpg', 'jpeg', 'svg'];
        for (const ext of extensions) {
            const iconPath = `../../assets/img/${iconName}.${ext}`;
            if (images[iconPath]) {
                const module = images[iconPath] as { default: string };
                return module.default;
            }
        }

        return undefined;
    }

    return {
        loadImage,
        imageSrc,
    }
}
